// Prompts editor — top-level route, gated behind VITE_FF_PROMPTS_EDITOR.
// -----------------------------------------------------------------
// Per docs/architecture/dispatches/m7-0-prompts-spa-port.md § 6.1 +
// § 1 (M7.0 mission).
//
// Replaces the Flask `/prompts` page (admin/routes/settings.py).
// When the flag is off (the M7.0 default in both staging and prod),
// the route mounts and immediately <Navigate replace />s to /hello,
// matching the M3.4 placeholder pattern + the
// dashboards/tour-planner gates.
//
// Flag flips at M7.0-L1 staging + M7.0-L2 prod per dispatch § 7.
// The Flask page itself remains accessible (localhost-only) until
// M7-mid retirement.

import { Navigate, createFileRoute } from '@tanstack/react-router';

import { PromptsPage } from '@/components/prompts/PromptsPage';
import { isFeatureEnabled } from '@/lib/featureFlags';

const PromptsRoute = () => {
  if (!isFeatureEnabled('PROMPTS_EDITOR')) {
    return <Navigate to='/hello' replace />;
  }
  return <PromptsPage />;
};

export const Route = createFileRoute('/_authenticated/prompts')({
  component: PromptsRoute,
});
